module.exports = "/_next/static/images/fe9f24f34585e7cacb71e790f1acfce4-rewards-app-md@3x.png";